const SK_KEY = '__sk'

export const setSecretKey = (sk) => {
  localStorage.setItem(SK_KEY, sk)
}

export const getSecretKey = () => {
  return localStorage.getItem(SK_KEY) || null
}
